/* eslint-disable sort-keys */
export const device = {
  smallMobile: "(max-width: 25rem)", // 400px for small screen mobile
  mobile: "(max-width: 37.5rem)", // 600px for mobile screen
  tablet: "(max-width: 56.25rem)", // 900px for tablets
  laptop: "(max-width: 80rem)", // 1280px for laptops
  desktop: "(max-width: 90rem)", // 1440px for desktop / monitors
  bigScreen: "(max-width: 120rem)", // 1920px for big screens
};
